<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    pagination="server"
                    :fields="fields"
                    :buttons="buttons"
                    :settings="false"
                    search
                    :initial-load="false"
                    :editor="(res) => res.Data.Data">
            <template #additional-actions>
                <div class="row align-items-center">
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.month">
                            <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.year">
                            <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                        </select>
                    </div>
                    <div class="col-md-3 mb-1 mb-md-0">
                        <v-select-list :options="employeeSalaryGroups" label="Value" v-model="employeeSalaryGroupId" placeholder="Tüm Maaş Grupları"></v-select-list>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-success" v-on:click="$refs.table.refresh()" :disabled="employeeSalaryGroupId == null">Sorgula</button>
                    </div>
                </div>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import EmployeeOperationsApi from '@/api/employee-operations';
import moment from 'moment'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard
    },
    data(){
        return{
            years:[],
            fields:[
                {key:'EmployeeFullName',name:'Personel',thClass:'w-100'},
                {key:'FileUploaded',name:'Bordro Yüklendi'},
            ],
            buttons:[
                { text:"İndir",key:"download",icon:"DownloadIcon",variant:"secondary",action:this.download, condition:(i) => i.FilePath},
            ],
            donem:{
                year:moment().year(),
                month:moment().month() + 1 
            },
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            employeeSalaryGroups:[],
            employeeSalaryGroupId:null
        }
    },
    mounted(){
        this.configureYears()
        this.getEmployeeSalaryGroups()
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.GSalaryFileUploadReportTable({
                ...this.filter,
                PaginateRequest:data
            })
        },
        getEmployeeSalaryGroups(){
            EmployeeOperationsApi.SalaryGroup.List().then(res=>{
                this.employeeSalaryGroups = res.data
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        download(i){
            if(i.FilePath){
                Additional.DownloadTab(i.FilePath)
            }
        }
    },
    computed:{
        filter(){
            return {
                EmployeeSalaryGroupId:this.employeeSalaryGroupId?.Key||null,
                Month: this.donem.month,
                Year: this.donem.year,
            }
        }
    }
}
</script>